import { apiSlice } from "../../app/apiSlice";
import { withDefaultMeta } from "../../util/withDefaultMeta";

export const userApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => {
    const query = withDefaultMeta(builder.query);
    const mutation = withDefaultMeta(builder.mutation);

    return {
      getUsers: query({
        query: () => "/users/all-users",
        providesTags: ["User"],
      }),

      updateProfile: mutation({
        query: (data) => ({
          url: "/users/profile-update",
          method: "PATCH",
          body: data,
        }),
        invalidatesTags: ["User"],
      }),

      updatePassword: mutation({
        query: (passwords) => ({
          url: "/users/update-password",
          method: "PUT",
          body: passwords,
        }),
        invalidatesTags: ["User"],
      }),

      getActivities: query({
        query: () => "/users/me/activities",
        providesTags: ["Activities"],
      }),

      // forgotPassword: mutation({
      //   query: (body) => ({
      //     url: "/users/forgot-password",
      //     method: "POST",
      //     body,
      //   }),
      //   invalidatesTags: ["User"],
      //   meta: { requiresAuth: false },
      // }),

      resetPassword: mutation({
        query: ({ resetToken, password }) => ({
          url: `/users/reset-password/${resetToken}`,
          method: "POST",
          body: { password },
          meta: { requiresAuth: false },
        }),
      }),

      updateNotificationSettings: mutation({
        query: (data) => ({
          url: "/users/profile/notifications",
          method: "PUT",
          body: data,
        }),
        invalidatesTags: ["User"],
      }),

      getUserById: query({
        query: (id) => ({
          url: `/users/${id}`,
          method: "GET",
        }),
        providesTags: ["User"],
      }),

      getMe: query({
        query: () => ({
          url: "/users/me",
          method: "GET",
        }),
        providesTags: ["User"],
      }),

      adminDeleteUser: mutation({
        query: ({ userId }) => ({
          url: `/users/delete/${userId}`,
          method: "DELETE",
        }),
        invalidatesTags: (result, error, arg) => [{ type: "User", id: arg.id }],
      }),
    };
  },
});

export const {
  useUpdateNotificationSettingsMutation,
  useGetActivitiesQuery,
  useGetMeQuery,
  useUpdateProfileMutation,
  useGetUsersQuery,
  // useForgotPasswordMutation,
  useResetPasswordMutation,
  useGetUserByIdQuery,
  useAdminDeleteUserMutation,
  useUpdatePasswordMutation,
} = userApiSlice;
